const _excluded = ["dashboardData"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { useTranslation } from 'react-i18next';
import DashCard from '../components/DashCard';
import HorizontalBarChart from '../components/HorizontalBarChart';
import TwoLinesVolumeChart from '../components/TwoLinesVolumeChart';

/**
 * Displays 2 overlapping lines showing the total cost and qe cost for the past
 * 3 years (past 3 claims).
 * The dasboardData param should total_costs_and_qe_costs_per_year field, which is an
 * object of the type: { 2022: { total: 2000, qe: 500 } }
 * 
 * @param {Object} dashboardData Should contain the total_costs_and_qe_costs_per_year field
 * @returns 
 */
const TotalAndQECostsPerYear = _ref => {
  let {
      dashboardData
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    t
  } = useTranslation();
  const {
    total_costs_and_qe_costs_per_year: costsPerYear
  } = dashboardData;
  const years = Object.keys(costsPerYear);
  const series = [{
    name: t('chart_total_net_spend'),
    data: Object.keys(costsPerYear).map(year => Math.round(costsPerYear[year].total))
  }, {
    name: t('chart_total_qe'),
    data: Object.keys(costsPerYear).map(year => Math.round(costsPerYear[year].qe))
  }];
  const legendTitles = [t('chart_total_net_spend'), t('chart_total_qe')];
  function renderChart() {
    if (years.length === 1) {
      const year = years[0];
      const data = [{
        label: "".concat(year, " QE"),
        value: Math.round(costsPerYear[year].qe),
        fillColor: '#80BBDC'
      }, {
        label: "".concat(year, " Total Cost"),
        value: Math.round(costsPerYear[year].total),
        fillColor: '#80BBDC'
      }];
      return /*#__PURE__*/React.createElement(HorizontalBarChart, {
        data: data,
        dataName: "Total Amount",
        formatTooltip: true
      });
    }
    return /*#__PURE__*/React.createElement(TwoLinesVolumeChart, {
      xAxisLabels: years,
      series: series,
      legendTitles: legendTitles
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DashCard, _extends({
    title: t('chart_title_qualifying_exp_and_total_potential_r&d_spend'),
    className: "h-100"
  }, props), renderChart()));
};
export default TotalAndQECostsPerYear;